import moment from "moment";

const fillMissedCandles = (list, stepInMin) => {
    if (!stepInMin) {
        throw 'step should be present';
    }
    const res = [];
    let added = false;
    let lastItem;
    list.forEach(item => {
        while (lastItem?.time && moment(item.time) > moment(lastItem.time).add(stepInMin, 'minutes')) {
            lastItem.time = moment(lastItem.time).add(stepInMin, 'minutes').toISOString();
            res.push({
                ...lastItem,
                date: new Date(lastItem.time),
                open: lastItem.close,
                low: lastItem.close,
                high: lastItem.close,
            });
            added = true;
        }
        lastItem = Object.assign({}, item);
        res.push(item);
    });
    return added ? res : list;
}

export default fillMissedCandles;
